var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "div",
        { staticClass: "tree-container" },
        [
          _c(
            "el-card",
            { attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("span", [_vm._v("下级用户树形结构")]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", padding: "3px 0" },
                      attrs: { type: "text" },
                      on: { click: _vm.getList }
                    },
                    [_vm._v("刷新")]
                  )
                ],
                1
              ),
              _c("el-tree", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.reqLoading,
                    expression: "reqLoading"
                  }
                ],
                staticClass: "custom-tree",
                attrs: {
                  data: _vm.treeData,
                  props: _vm.defaultProps,
                  "node-key": "id",
                  "default-expand-all": "",
                  "expand-on-click-node": false
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c(
                          "span",
                          { staticClass: "node-left" },
                          [
                            _c("i", {
                              staticClass: "icon-tag",
                              class:
                                data.children && data.children.length
                                  ? "el-icon-folder"
                                  : "el-icon-user"
                            }),
                            _c(
                              "el-dropdown",
                              {
                                attrs: { trigger: "click" },
                                on: {
                                  command: function(cmd) {
                                    return _vm.handleCommand(cmd, data)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "username-text" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(data.nickname || "未命名用户") +
                                      " "
                                  ),
                                  _c("span", { staticClass: "email-tip" }, [
                                    _vm._v("(" + _vm._s(data.email) + ")")
                                  ])
                                ]),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "editUser",
                                          icon: "el-icon-edit"
                                        }
                                      },
                                      [_vm._v("修改用户信息")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "editProduct",
                                          icon: "el-icon-s-goods"
                                        }
                                      },
                                      [_vm._v("修改产品")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("modifyUser", { ref: "modifyUser" }),
      _c("modifyAppList", { ref: "modifyAppList" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }